import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AuthHttpService} from '../core/auth-http.service';
import {environment} from '../../environments/environment';
import { catchError } from 'rxjs/operators';

import { Report } from './report';


@Injectable()
export class ReportsService {

  constructor(private http: AuthHttpService) {}

  list(): Observable<any> {
    return this.http.getV3(`${environment.apiv3url}/quicksight_reports`).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  create(report: Report): Observable<any> {
    return this.http.postV3(`${environment.apiv3url}/quicksight_reports`, report).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  update(id:string, report: Report): Observable<any> {
    return this.http.updateV3(`${environment.apiv3url}/quicksight_reports/${id}`, report).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  delete(id): Observable<any> {
    return this.http.deleteV3(`${environment.apiv3url}/quicksight_reports/${id}`);
  }
}
